var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 .71h14.29V15H0V.71z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.452 12.878c0 .696-.566 1.282-1.262 1.282H2.102c-.695 0-1.261-.586-1.261-1.282V2.79c0-.695.566-1.24 1.261-1.24h5.885V.71H2.102A2.087 2.087 0 000 2.79v10.088C0 14.038.943 15 2.102 15H12.19c1.158 0 2.101-.964 2.101-2.122V7.014h-.84v5.864z",
    fill: "#000"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.94 2.208l-.29.29-1.16-1.162.29-.29a.84.84 0 011.16 0 .822.822 0 010 1.162zm-5.42 5.43l-1.547.387.387-1.55 4.55-4.557 1.16 1.161-4.55 4.559zm6-7.172c-.62-.621-1.7-.621-2.32 0l-5.5 5.51a.41.41 0 00-.109.19L6.012 8.49A.413.413 0 006.41 9a.398.398 0 00.1-.012l2.32-.581a.406.406 0 00.19-.108l5.5-5.51c.31-.31.481-.723.481-1.162 0-.44-.17-.851-.48-1.161z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.6f1aeca1c387ea317c8b71ebeff98030.svg";
export { ForwardRef as ReactComponent };